import { selectLobbyJoinSoundEnabled } from 'features/room/roomSlice';
import { select } from 'redux-saga/effects';
import { safeLocalStorage } from 'utils/storage';

export function* lobbyJoinSoundChangedSaga() {
  const lobbyJoinSoundEnabled: boolean = yield select(selectLobbyJoinSoundEnabled);

  safeLocalStorage.setItem(`lobby_join_sound`, `${lobbyJoinSoundEnabled}`);
}
